import intl from "react-intl-universal";
import { KYC_STATUS } from "../constants";

export const CrossborderKycStatusBadge = ({ status }) => {
  const meta = KYC_STATUS[status] ?? {
    labelKey: null,
    badgeClass: "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-300",
  };

  const label = meta.labelKey ? intl.get(meta.labelKey) : status;

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${meta.badgeClass}`}
    >
      {label}
    </span>
  );
};
